import "rc-steps/assets/index.css";
import Steps, { Step } from "rc-steps";

export type FormStepperProps = {
  steps: { label: string }[];
  activeStep: number;
  width?: number;
};

export function FormStepper({
  steps,
  activeStep,
  width = 100,
}: FormStepperProps) {
  return (
    <Steps current={activeStep} style={{ width: `${width}%` }}>
      {steps.map((step, index) => (
        <Step title={step.label} key={index} />
      ))}
    </Steps>
  );
}

export default FormStepper;
